import { MmAlertMode, MmAlertService, MmAlertSize, MmAlertType } from '@metromarkets/components';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { NUMBER_1 } from '~shared/constants';
import { BusinessStatus, VatNumberErrors } from '~app/modules/authorization/constants/business-status.constant';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { FF_STATIC_BLOCKED_VAT_IDS } from '../constants/authorization.constant';
import { ApplicationAuthorizationActionType, BlockedTaxNumberLabel } from '~shared/modules/application-event/constants';
import { BlockedVatIdsEvent } from '~shared/modules/application-event/models/blocked-vat-ids-event.model';

@Injectable({
  providedIn: 'root',
})
export class TierTwoRegistrationPromptService {
  constructor(
    private alertService: MmAlertService,
    private translateService: TranslateService,
    private applicationEventService: ApplicationEventService
  ) {}

  handleInvalidKVKNumber() {
    const titleKVKError = 'PAGES.AUTH.KVK.ERROR.KVK_NUMBER_NOT_VALID.TITLE';
    const messageKVKError = 'PAGES.AUTH.KVK.ERROR.KVK_NUMBER_NOT_VALID.MESSAGE';

    this.translateService
      .get([titleKVKError, messageKVKError])
      .pipe(take(NUMBER_1))
      .subscribe((translations) => {
        this.alertService.addAlert({
          type: MmAlertType.error,
          title: translations[titleKVKError],
          message: translations[messageKVKError],
          mode: MmAlertMode.banner,
          size: MmAlertSize.large,
          duration: 4000,
          contentAlign: 'center',
        });
      });
  }

  handleInvalidVatNumber(error) {
    let vatNumberTitleAlert = '';
    let vatNumberAlert = '';

    if (error === BusinessStatus.blocked) {
      vatNumberTitleAlert = VatNumberErrors.VatNumberBlockedTitleAlert;
      vatNumberAlert = VatNumberErrors.VatNumberBlockedAlert;
    } else {
      vatNumberTitleAlert = VatNumberErrors.VatNumberNotValidTitleAlert;
      vatNumberAlert = VatNumberErrors.VatNumberNotValidAlertOnVATIdCheck;
    }

    return { vatNumberTitleAlert, vatNumberAlert };
  }

  public handleBlockedVatIdAccount() {
    this.applicationEventService.publishIfFFEnabled(
      FF_STATIC_BLOCKED_VAT_IDS,
      new BlockedVatIdsEvent(
        ApplicationAuthorizationActionType.BlockedTaxNumber,
        BlockedTaxNumberLabel.HotelGroupTaxNumber
      )
    );
    const title = 'REGULAR.BLOCKED_VAT_ID.ALERT.TITLE';
    const message = 'REGULAR.BLOCKED_VAT_ID.ALERT.MESSAGE';

    this.translateService
      .get([title, message])
      .pipe(take(NUMBER_1))
      .subscribe((translations) => {
        this.alertService.addAlert({
          type: MmAlertType.warning,
          title: translations[title],
          message: translations[message],
          mode: MmAlertMode.alert,
          size: MmAlertSize.large,
        });
      });
  }
}
